import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import ConfirmationModal from 'layout/molecules/ConfirmationModal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { removeRelease, selectWarehouseReleasesStatus } from 'store/warehouseReleasesSlice';
function RemoveWarehouseReleaseModal() {
    var _a;
    const { t } = useTranslation(['warehouseReleases', 'common']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const modalData = (_a = useSelector(selectModalByName('removeWarehouseRelease'))) === null || _a === void 0 ? void 0 : _a.data;
    const status = useSelector(selectWarehouseReleasesStatus);
    const releaseId = modalData === null || modalData === void 0 ? void 0 : modalData.id;
    const releaseName = modalData === null || modalData === void 0 ? void 0 : modalData.releaseId;
    const redirectTo = modalData === null || modalData === void 0 ? void 0 : modalData.redirectTo;
    const handleRemove = () => {
        dispatch(removeRelease(releaseId))
            .unwrap()
            .then(() => {
            dispatch(closeModal({ name: 'removeWarehouseRelease' }));
            if (redirectTo)
                navigate(redirectTo);
        });
    };
    return (React.createElement(ConfirmationModal, { name: "removeWarehouseRelease", header: React.createElement(React.Fragment, null,
            React.createElement(TrashSvg, null),
            t('REMOVE_WAREHOUSE_RELEASE')), buttons: React.createElement(Button, { color: "danger", onClick: handleRemove }, t('common:delete')), action: handleRemove, loading: status.remove === 'loading' },
        React.createElement("h2", null, t('REMOVE_WAREHOUSE_RELEASE_HEADER', { releaseName })),
        React.createElement("p", null, t('REMOVE_WAREHOUSE_RELEASE_MESSAGE'))));
}
export default memo(RemoveWarehouseReleaseModal);
